"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _itemContainer = _interopRequireDefault(require("../item/itemContainer.js"));

var _galleryComponent = require("../galleryComponent");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var GroupView =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(GroupView, _GalleryComponent);

  function GroupView(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.displayName = 'GroupView';
    _this.dom = [];
    _this.state = {};
    return _this;
  }

  var _proto = GroupView.prototype;

  _proto.createDom = function createDom(visible) {
    var _this2 = this;

    return this.props.items.map(function (item) {
      return _react["default"].createElement(_itemContainer["default"], _objectSpread({}, item.renderProps(Object.assign(_this2.props.galleryConfig, {
        visible: visible
      })), {}, _this2.props.itemsLoveData[item.id]));
    });
  };

  _proto.render = function render() {
    return _react["default"].createElement("div", {
      key: "group_" + this.props.idx,
      "data-hook": 'group-view'
    }, this.createDom(true));
  };

  return GroupView;
}(_galleryComponent.GalleryComponent);

var _default = GroupView;
exports["default"] = _default;